import { useTranslate } from '@tolgee/react';
import { Button, Checkbox, Popover } from 'antd';
import SafeImage from 'components/SafeImage';
import StatusButton from 'components/StatusButton';
import useIM from 'hooks/business/im/useIM';
import { useState } from 'react';
import Copy from './Copy';
import { DownOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

function SendLogistics({
  conversation,
  logisticsList,
}: {
  conversation: Conversation.Conversation;
  logisticsList: Conversation.Trade.Logistics[];
}) {
  const { conversationId } = conversation;

  const { t } = useTranslate();

  const { sendTtsLogisticsCard } = useIM();

  const [visible, setVisible] = useState(false);

  const [selected, setSelected] = useState<Conversation.Trade.Logistics[]>([]);

  if (!logisticsList.length) {
    return <></>;
  }

  const send = ({ externalTradeId, packageNumber }: Conversation.Trade.Logistics) =>
    sendTtsLogisticsCard(conversationId, {
      orderId: externalTradeId,
      packageId: packageNumber,
    });

  if (logisticsList.length === 1) {
    return (
      <StatusButton size="small" type="link" onClick={() => send(logisticsList[0])}>
        {t('发送物流卡片')}
      </StatusButton>
    );
  }

  return (
    <Popover
      trigger={['click']}
      placement="bottomRight"
      visible={visible}
      onVisibleChange={(visible) => {
        setVisible(visible);
        if (visible && selected.length) {
          setSelected([]);
        }
      }}
      content={
        <Content>
          <ul>
            {logisticsList.map((logistics) => {
              const { packageNumber, trackingNumber, packageItem } = logistics;
              return (
                <li key={packageNumber}>
                  <Checkbox
                    checked={selected.some((_) => _.packageNumber === packageNumber)}
                    onChange={({ target: { checked } }) =>
                      setSelected(
                        checked
                          ? [...selected, logistics]
                          : selected.filter((_) => _.packageNumber !== packageNumber),
                      )
                    }
                  />
                  <SafeImage width={48} height={48} src={packageItem?.[0]?.itemPic} />
                  <p>
                    {t('物流单号')}：{trackingNumber}
                    <Copy
                      text={trackingNumber}
                      successMessage={t('trade.copyLogisticsSucceed')}
                      failedMessage={t('trade.copyLogisticsFailed')}
                    />
                  </p>
                </li>
              );
            })}
          </ul>
          <div>
            <Button size="small" onClick={() => setVisible(false)}>
              {t('取消')}
            </Button>
            <StatusButton
              disabled={!selected.length}
              size="small"
              type="primary"
              onClick={() => {
                setVisible(false);
                return selected.reduce<Promise<any>>(
                  (res, logistics) => res.then(() => send(logistics)),
                  Promise.resolve(),
                );
              }}
            >
              {t('phrase.确定')}
            </StatusButton>
          </div>
        </Content>
      }
    >
      <Button size="small" type="link">
        {t('发送物流卡片')}
        <DownOutlined />
      </Button>
    </Popover>
  );
}

const Content = styled.div`
  margin: -12px -16px;
  padding: 14px;
  background: #f6faff;
  > ul {
    margin: 0;
    padding: 0;
    list-style: none;
    > li {
      display: flex;
      align-items: center;
      padding: 4px;
      margin-bottom: 6px;
      background: #fff;
      border: solid 1px #e4e7ee;
      > * {
        margin-right: 4px;
      }
      > p {
        margin-bottom: 0;
        > span {
          margin-left: 4px;
        }
      }
    }
  }
  > div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    > * {
      margin-left: 8px;
    }
  }
`;

export default SendLogistics;
